module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAAAXNSR0IArs4c6QAAAAZQTFRFAAAAfX6ApUqVlAAAAAF0Uk5TAEDm2GYAAAA7SURBVBjTY2AgAPj//z/8//8HDJqPgfFwA0MBzWiQPdhoIGDGRyOrR3cvlD4AUoyHRldPN/9iC2cCAABI330ptbxuVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/cube-icon.png
// module id = TrMw
// module chunks = 243